import React from 'react';

const Text = ({ className, size }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="4" fill="white" />
            <path d="M5.894 17L10.529 6.5H13.454L18.104 17H15.014L11.384 7.955H12.554L8.924 17H5.894ZM8.429 14.96L9.194 12.77H14.324L15.089 14.96H8.429Z" fill="black" />
        </svg>
    )
}

export default Text;